"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hyperlink = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var Icon_1 = require("../Icon/Icon");
require("./hyperlink.css");
exports.Hyperlink = React.memo(function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.borderless, borderless = _c === void 0 ? false : _c, props = __rest(_a, ["style", "borderless"]);
    var renderBody = function (p) {
        switch (p.type) {
            case 'click':
                return (0, jsx_runtime_1.jsx)("span", __assign({ onClick: p.onClick }, { children: p.label }));
            case 'link':
                return ((0, jsx_runtime_1.jsx)(p.LinkComponent, __assign({ to: p.href, onClick: p.onClick }, { children: p.label })));
            case 'link-real':
                return ((0, jsx_runtime_1.jsx)("a", __assign({ href: p.href, target: p.target ? p.target : '_self' }, { children: p.label })));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('hyperlink', props.arrowSide, { borderless: borderless }), style: style }, { children: [props.icon ? (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: props.icon.type, className: "size-".concat(props.icon.size) }) : null, renderBody(props)] })));
});
//# sourceMappingURL=Hyperlink.js.map